import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";

@Component({
	selector: "app-socket-message",
	templateUrl: "./socket-message.component.html",
	styleUrls: ["../../../commandcenter.scss"],
})
export class SocketMessageComponent implements OnInit {
	@Input() message: SocketMessage;
	@Output() messageChange = new EventEmitter<SocketMessage>();
	constructor(public app: AppService) {}

	ngOnInit(): void {}
}

interface SocketMessage {
	action?: string;
	key?: string;
	message?: string;
	receivedDateTime?: Date;
	venueKey?: number;
}
